import { createStyles } from "antd-style";
import { formPrefixCls } from "@/base/components/index";

export const useModalPaymentMethodViewStyles = createStyles(({ css }: any) => ({
  root: css``,
  form: css`
    .${formPrefixCls}-item-label {
      padding-bottom: 0;
    }
  `,
  actions: css``,
}));
